<template>
  <div id="app" :style="'height:'+fullHeight+'px;'">
    <keep-alive exclude="addressEdit,AnswerDetail">
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
    export default {
        name: 'App',
        data() {
            return {
                fullHeight: document.documentElement.clientHeight - 16,
            }
        },
        mounted() {
            this.get_bodyHeight()
        },
        methods :{
            get_bodyHeight () {//动态获取浏览器高度
                const that = this
                window.onresize = () => {
                    return (() => {
                        window.fullHeight = document.documentElement.clientHeight
                        that.fullHeight = window.fullHeight
                    })()
                }
            }
        },
        watch: {
            fullHeight (val){//监控浏览器高度变化
                if(!this.timer) {
                    this.fullHeight = val
                    this.timer = true
                    let that = this
                    setTimeout(function (){
                        that.timer = false
                    },400)
                }

            }
        }
    }
</script>

<style>
  html {
    height: 100%;
    width: 100%;
    display: table;
  }
  body {
    margin: 0;
    padding: 0;
    display: table-cell;
    height: 100%;
    width: 100%;
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin: 8px 8px 8px 8px;
  }

  .info-background {
    /*background: #f1f1f150;*/
    /*border-radius: 10px;*/
    min-height: 36px;
    /*margin-bottom: 15px;*/
  }

  .back-icon {
    float: left;
    margin: 0px 0px 0px 0px;
    font-size: 20px;
    position: relative;
    top: 29%;
  }

  .info-divider {
    margin: 12px 0 !important;
  }

  .el-divider__text {
    padding: 0 15px !important;
    font-size: 13px !important;
    color: #909399 !important;
  }

  .product-img {
    width: 90px;
    height: 90px;
    float: right;
  }

  .upload-tip {
    font-size: 12px;
    color: #606266;
    margin: 10px 0px;
  }

  .submit-btn {
    margin: 10px 0px;
    width: 100px;
  }

  .prolist-div {
    position: relative;
    flex: 0 0 auto;
    width: 92px;
    height: 114px;
    margin: 1px;
    padding: 6px;
    border: 1px solid #CACACA;
    border-radius: 8px;
    margin-left: 12px;
    display: inline-block;
  }

  .message-logout {
    width: 300px!important;
  }
  .el-loading-spinner {
    margin-top: 0px!important;
  }

  .el-radio__label {
    font-size: 14px !important;
  }

  .picker-items{ 
    width:100% !important;
  }
</style>
